import MultiLineField from '@mui/material/TextField'
import { ValidationErrors } from 'utils/enum'
import { styled } from '@stitches/react'
import * as Yup from 'yup'
import { useForm } from 'react-hook-form'
import { StyledDropdownWrap } from 'components/form/Textfield.styles'
import { Box } from 'components/elements'
import { yupResolver } from '@hookform/resolvers/yup'
import { Button } from 'components/button'
import { useEditComment } from '../api/editComment'
import { AxiosError } from 'axios'
import { errorMessage } from 'utils/function'
import { useState } from 'react'
import { CommentsData, EditCommentData, EditCommentFormFields } from './type'
import { CommentBox } from './Comment'
import { wrapStyle } from 'views/Support/SupportForm'
import { ButtonWrap, KeyButtonCSS } from 'features/profile/components/EditProfileForm'

type EditData = {
  item: CommentsData
  setEdit: (value: boolean) => void
  setEditFlag: (value: boolean) => void
  setEditNotification: (value: boolean) => void
}
export const OnEdit = ({ item, setEdit, setEditFlag, setEditNotification }: EditData) => {
  const [submitError, setSubmitError] = useState('')

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<EditCommentFormFields>({
    resolver: yupResolver(commentSchema),
    defaultValues: {
      message: item?.message || '',
    },
  })
  const { mutate: updateForm, isLoading: formLoading } = useEditComment()
  const onSubmit = (data: { message: string }) => {
    setSubmitError('')

    const EditComment: EditCommentData = {
      message: String(data.message),
      id: item.id,
    }
    updateForm(EditComment, {
      onSuccess: () => {
        setEditNotification(true)
        setEditFlag(true)
        setEdit(false)
        setSubmitError('')
      },
      onError: error => {
        if (error instanceof AxiosError) {
          setSubmitError(errorMessage(error))
        }
      },
    })
  }
  return (
    <CommentBox css={{ padding: '0 0 0 1rem' }}>
      <form onSubmit={handleSubmit(onSubmit)} style={{ marginBottom: 0 }}>
        {!!submitError && <ErrorBox>{submitError}</ErrorBox>}

        <StyledDropdownWrap className="comment">
          <MultiLineField multiline rows={1} type="text" style={{ width: '100%', height: '80%' }} className="main" {...register('message')} defaultValue={item?.message || ''} />

          {errors.message && (
            <Box as="p" className="Error " style={{ color: '$red' }}>
              {errors?.message.message}
            </Box>
          )}
        </StyledDropdownWrap>

        <ButtonWrap css={{ ...wrapStyle, mt: '$3' }}>
          <Button bordered={true} type="button" onClick={() => setEdit(false)} css={KeyButtonCSS}>
            Cancel
          </Button>
          <Button type="submit" disabled={formLoading} css={KeyButtonCSS}>
            {formLoading ? 'Updating' : 'Update'}
          </Button>
        </ButtonWrap>
      </form>
    </CommentBox>
  )
}
const commentSchema = Yup.object().shape({
  message: Yup.string().required(ValidationErrors.Message),
})

const ErrorBox = styled('div', {
  gridColumn: 'span 2',
  gridRow: 'span 3',
  margin: 0,
  color: '$error',
})
